import PaymentOrdersPage from './PaymentOrdersPage';

export default PaymentOrdersPage;
